import styled from '@emotion/styled'
import { Dispatch, SetStateAction } from 'react'
import { useTranslation } from 'next-i18next'
import {
  BottomSection,
  Button,
  CourseAmountButton,
  TitleSection,
} from '../../styled.components'
import { motion } from 'framer-motion'

type Props = {
  setCurrentStep: Dispatch<
    SetStateAction<
      'stepone' | 'steptwo' | 'stepthree' | 'stepfour' | 'stepfive'
    >
  >
  setAmountOfCourses: Dispatch<SetStateAction<'0to1' | '1to5' | '6plus'>>
  amountOfCourses: '0to1' | '1to5' | '6plus'
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3.5rem;
  max-width: 340px;
  margin: 2rem auto;
  margin-top: 0rem;
`
const OptionsSelection = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: center;
`

const StepOne = ({
  amountOfCourses,
  setAmountOfCourses,
  setCurrentStep,
}: Props) => {
  const { t } = useTranslation(['landingPage'])
  const handleChangeAomunt = (amount: '0to1' | '1to5' | '6plus') => {
    setAmountOfCourses(amount)
  }

  return (
    <motion.div
      initial={{ opacity: 0, translateY: 100 }}
      animate={{
        opacity: 1,
        translateY: 0,
      }}
      transition={{
        duration: 0.3,
      }}
    >
      <Container>
        <TitleSection>{t('connectWithUs.stepOne.title')}</TitleSection>
        <OptionsSelection>
          <CourseAmountButton
            onClick={() => handleChangeAomunt('0to1')}
            active={amountOfCourses === '0to1'}
            width="6rem"
          >
            {t('connectWithUs.stepOne.options.0to1')}
          </CourseAmountButton>
          <CourseAmountButton
            onClick={() => handleChangeAomunt('1to5')}
            active={amountOfCourses === '1to5'}
            width="6rem"
          >
            {t('connectWithUs.stepOne.options.2to5')}
          </CourseAmountButton>
          <CourseAmountButton
            onClick={() => handleChangeAomunt('6plus')}
            active={amountOfCourses === '6plus'}
            width="6rem"
          >
            {t('connectWithUs.stepOne.options.6plus')}
          </CourseAmountButton>
        </OptionsSelection>
        <BottomSection>
          <Button className="ml-auto" onClick={() => setCurrentStep('steptwo')}>
            {t('connectWithUs.stepOne.nextStep')}
          </Button>
        </BottomSection>
      </Container>
    </motion.div>
  )
}

export default StepOne
